import MainPage from "../templatePage/templatePage";
import ManageUsers from "./ManageUsers";
import ErrorBoundary from "../common/ErrorBoundary";

const UsersPage = () => {
    return (
        <MainPage 
            component={
                <ErrorBoundary>
                    <ManageUsers />
                </ErrorBoundary>
            } 
        />
    );
};

export default UsersPage;
